import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { formatDateStrWithYearAndDay, formatTimeStr } from 'utils';
import CoopCalendarSyncButton from '../../business/ManageAppointmentPage/CoopCalendarSyncButton';

function VirtualTourInfoTable({
  virtualTour,
  retsId,
  dashboardId,
  virtualShowingDomain,
}) {
  const DEFAULT_VIRTUAL_SHOWING_DOMAIN =
    virtualShowingDomain || 'https://edge.brokerbay.com/virtual_showing/';
  const link = `${DEFAULT_VIRTUAL_SHOWING_DOMAIN}${virtualTour.room}`;
  const [tooltipText, setTooltipText] = useState('Copy Link');

  const copyLink = () => {
    navigator.clipboard.writeText(link);
    setTooltipText('Copied');
  };

  return (
    <table className="table" style={{ width: '100%', tableLayout: 'fixed' }}>
      <tbody>
        <tr>
          <td className="table-key">Virtual Tour</td>
          <td data-cy="tour-name">{virtualTour.tourName}</td>
        </tr>
        <tr>
          <td className="table-key">Date</td>
          <td data-cy="tour-date">
            <div>
              <strong>
                {formatDateStrWithYearAndDay(
                  virtualTour.startTime,
                  virtualTour.timezone,
                )}
              </strong>
            </div>
            <div>
              {formatTimeStr(virtualTour.startTime, virtualTour.timezone)}
            </div>
            {(retsId || dashboardId) && (
              <CoopCalendarSyncButton
                virtualTour={virtualTour}
                almanacUrl={
                  retsId
                    ? `/external/rets/${retsId}/almanac`
                    : `/external/dash/${dashboardId}/almanac`
                }
                retsId={retsId}
                dashboardId={dashboardId}
                isTour
              />
            )}
          </td>
        </tr>
        <tr>
          <td className="table-key">Conference Link</td>
          <td style={{ wordWrap: 'break-word' }} data-cy="tour-link">
            <a href={link}>{link}</a>{' '}
            <Tooltip title={tooltipText} className="margin-left">
              <a onClick={copyLink} className="fa fa-copy "></a>
            </Tooltip>
          </td>
        </tr>
        <tr>
          <td className="table-key">Host PIN</td>
          <td data-cy="tour-pin">
            <b>
              <h4>{virtualTour.pin}</h4>
            </b>
          </td>
        </tr>
        <tr>
          <td className="table-key">Invites Sent</td>
          <td className="appointment-status" data-cy="tour-invites">
            {virtualTour.invitees &&
              virtualTour.invitees.map((invitee, i) => (
                <div key={i}>
                  <strong>{invitee.name}</strong>
                  {invitee.email && `, ${invitee.email}`}
                  <br />
                  <br />
                </div>
              ))}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default VirtualTourInfoTable;
